import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormDescription, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Textarea } from '@fortem-monorepo/react-ui'

import { GuidelineFormValues } from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

export interface DescriptionFieldProps {}

export const DescriptionField: React.FC<DescriptionFieldProps> = ({}) => {
  const { control, register } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="description"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Description</FormLabel>
              <FormError />
            </div>
            <FormDescription>
              This field will be visible to investors on the report page.
            </FormDescription>
            <Textarea {...register('description')} />
          </FormItem>
        )
      }}
    />
  )
}
